import { createRoute, lazyRouteComponent } from '@tanstack/react-router'

import { requireBackoffice } from '../auth/guard.ts'
import { numericIdParam } from './params.ts'
import { rootRoute } from './root.tsx'

/** An account's card as a link target. `$id` is an app_user id, not a person id. */
export function userCardLink(userId: number) {
  return { to: '/users/$id', params: { id: userId } } as const
}

export const userDetailRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/users/$id',
  params: numericIdParam,
  beforeLoad: requireBackoffice,
  component: lazyRouteComponent(() => import('../pages/user-detail.tsx')),
})
